import { createContext } from "react";

import { IContextApp } from "./app.types";

export const ContextApp = createContext<IContextApp>(
  null as unknown as IContextApp,
);
